(function () {
  const root = document.querySelector("[data-carousel]");
  if (!root) return;
  const track = root.querySelector("[data-carousel-track]");
  const viewport = root.querySelector(".carousel-viewport") || root.querySelector(".jg-carousel-viewport");
  if (!track || !viewport) return;

  const autoplay = root.dataset.autoplay === "true";
  const interval = parseInt(root.dataset.interval) || 5000;
  const speed = parseInt(root.dataset.speed) || 800;
  
  const originalCards = Array.from(track.querySelectorAll("[data-card]"));
  const n = originalCards.length;
  if (n === 0) return;

  // Crucial : Le track est relatif pour mesurer la position des cartes
  track.style.position = "relative";

  function rebuild() {
    track.innerHTML = "";
    const makeBlock = () => originalCards.map(c => c.cloneNode(true));
    // Crée 3 blocs identiques pour le loop infini
    [...makeBlock(), ...makeBlock(), ...makeBlock()].forEach(c => track.appendChild(c));
  }
  rebuild();

  const cards = Array.from(track.querySelectorAll("[data-card]"));
  let active = n; 
  let timer = null;
  let locked = false;

  function centerActive(animate = true) {
    const card = cards[active];
    if (!card) return;

    // Calcul du centrage : Largeur de l'écran / 2 - (Position de la carte + Moitié de la carte)
    const vpW = viewport.getBoundingClientRect().width;
    const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
    const targetX = (vpW / 2) - cardCenter;

    track.style.transition = animate ? `transform ${speed}ms cubic-bezier(0.2, 1, 0.3, 1)` : "none";
    track.style.transform = `translate3d(${targetX}px, 0, 0)`;

    cards.forEach((c, i) => c.classList.toggle("is-active", i === active));
  }

  function jumpIfNeeded() {
    if (active < n) {
      active += n;
      centerActive(false);
    } else if (active >= 2 * n) {
      active -= n;
      centerActive(false);
    }
  }

  function move(direction) {
    if (locked) return;
    locked = true;
    active += direction;
    centerActive(true);
    
    setTimeout(() => {
      jumpIfNeeded();
      locked = false;
    }, speed + 20);
  }

  function next() { move(1); }
  function prev() { move(-1); }

  function startAutoplay() {
    clearInterval(timer);
    if (autoplay) timer = setInterval(next, interval);
  }

  // --- SMART SWIPE MOBILE ---
  let startX = 0;
  let startY = 0;
  let isDragging = false;

  viewport.addEventListener("touchstart", (e) => {
    isDragging = true;
    clearInterval(timer);
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  viewport.addEventListener("touchend", (e) => {
    if (!isDragging) return;
    isDragging = false;
    
    const diffX = e.changedTouches[0].clientX - startX;
    const diffY = e.changedTouches[0].clientY - startY;

    // Si le mouvement est plus horizontal que vertical (ne bloque pas le scroll)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
      if (diffX > 0) prev();
      else next();
    }
    
    startAutoplay();
  }, { passive: true });

  root.addEventListener("mouseenter", () => clearInterval(timer));
  root.addEventListener("mouseleave", startAutoplay);
  window.addEventListener("resize", () => centerActive(false));

  // Initialisation avec léger délai pour laisser le CSS (vw) s'appliquer
  setTimeout(() => {
    centerActive(false);
    startAutoplay();
  }, 150);
})();